(function () {
    "use strict";

    // @ngInject
    function TwoFactorAuthModalControllerCtor($scope, $injector, $modalInstance, UsersManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TwoFactorAuthModalController';

        this.UsersManager = UsersManager;
        this.modalInstance = $modalInstance;
    }

    Controllers.TwoFactorAuthModalController = Class(Controllers.BaseController, {

        constructor: TwoFactorAuthModalControllerCtor,

        onCodeVerificationSet: function onCodeVerificationSet(code, justClose) {
            if (justClose) {
                this.modalInstance.dismiss('cancel');
            } else {
                this.modalInstance.close(code);
            }
        },

        // validateVerificationCode: function validateVerificationCode(verificationCode) {
        //     this.UsersManager.validatePhoneVerificationCode(verificationCode).then(function success() {
        //         this.modalInstance.close(verificationCode);
        //     }.bind(this), function error() {
        //         this.modalInstance.close('invalid');
        //     }.bind(this));
        // },

    });
}());

